import {
    Autocomplete,
    Box,
    Card,
    Grid,
    TextField,
    Typography,
} from '@mui/material';

const style = {
    p: 0,
    width: '98%',
    textAlign: 'left',
    marginLeft: '15px',
};

const ListHeader = ({
    search,
    setSearch,
    departamentos,
    ciudades,
    divisiones,
    sectores,
    canales,
    pais,
}) => {
    const handleChangeNombre = (e) => {
        setTimeout(() => {
            setSearch({ ...search, nombre: e.target.value });
        }, 2000);
    };

    const handleDepartamentoSelected = (_, value) => {
        setSearch({
            ...search,
            departamento: value?.id || '',
            ciudad: value?.id ? search.ciudad : '',
        });
    };

    const handleCiudadSelected = (_, value) => {
        setSearch({ ...search, ciudad: value?.id || '' });
    };

    const handleDivisionSelected = (_, value) => {
        setSearch({ ...search, division: value?.id || '' });
    };

    const handleCanalSelected = (_, value) => {
        setSearch({ ...search, canal: value?.id || '' });
    };

    const handleSectorSelected = (_, value) => {
        setSearch({ ...search, sector: value?.id || '' });
    };

    return (
        <Box sx={style} component="form">
            <Grid container pt={1} alignItems="center" justifyContent="center">
                <Grid item xs={12} md={9}>
                    <Card
                        variant="outlined"
                        sx={{ backgroundColor: '#D9D9D9' }}
                    >
                        <Grid
                            container
                            py={2}
                            px={2}
                            justifyContent="space-between"
                            alignItems="flex-start"
                        >
                            <Grid item xs={12} md={12}>
                                <Typography color="primary" variant="h6">
                                    Filtros
                                </Typography>
                            </Grid>
                            <Grid item xs={2} md="auto">
                                <TextField
                                    label="Nombre"
                                    size="small"
                                    variant="standard"
                                    onChange={handleChangeNombre}
                                ></TextField>
                            </Grid>
                            <Grid item xs={12} md={2.3}>
                                <Autocomplete
                                    options={departamentos}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={handleDepartamentoSelected}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder=""
                                            variant="standard"
                                            label={
                                                pais === 'colombia'
                                                    ? 'Departamentos'
                                                    : 'Provincias'
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                            {search.departamento && (
                                <Grid item xs={12} md={2}>
                                    <Autocomplete
                                        options={ciudades}
                                        getOptionLabel={(option) =>
                                            option.nombre
                                        }
                                        onChange={handleCiudadSelected}
                                        size="small"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder=""
                                                variant="standard"
                                                label="Ciudades"
                                            />
                                        )}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={2} md={2}>
                                <Autocomplete
                                    options={divisiones}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={handleDivisionSelected}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder=""
                                            variant="standard"
                                            label="Divisiones"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <Autocomplete
                                    options={sectores}
                                    getOptionLabel={(option) => option.sector}
                                    onChange={handleSectorSelected}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder=""
                                            variant="standard"
                                            label="Sectores"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <Autocomplete
                                    options={canales}
                                    getOptionLabel={(option) => option.canal}
                                    onChange={handleCanalSelected}
                                    size="small"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder=""
                                            variant="standard"
                                            label="Canales"
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ListHeader;
